import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from 'seagull';
import { Box } from 'seagull/components/Layout';
import { Bell } from 'seagull/icons';
import { useEventReporter } from '~/event-reporter';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import styles from './InAppNotificationsButton.module.scss';
export function InAppNotificationsButton() {
    const { setInAppNotificationsDrawerOpen, logBI } = useStoreActions();
    const showNotificationPimple = useStore((state)=>state.showNotificationPimple);
    const inAppNotificationsDrawerOpen = useStore((state)=>state.inAppNotificationsDrawerOpen);
    const email = useStore(selectors.user.email);
    const { reportToHeap } = useEventReporter();
    const handleClick = ()=>{
        logBI(15000);
        reportToHeap('sidebar', 'click', 'vendor-clicked-notifications-btn', {
            email
        });
        setInAppNotificationsDrawerOpen(!inAppNotificationsDrawerOpen);
    };
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.root,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: inAppNotificationsDrawerOpen ? 'in_app_notifications_close' : 'in_app_notifications_open'
                },
                skin: inAppNotificationsDrawerOpen ? 'primaryTransparentBoxed' : 'transparent',
                testId: "home-sidebar-notification-center",
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(Bell, {})
            }),
            showNotificationPimple && /*#__PURE__*/ _jsx(Box, {
                className: styles.pimple,
                testId: "home-sidebar-notification-center-pimple"
            })
        ]
    });
}
